<template>
  <div class="fixed bottom-0 w-100 pdpa-container" v-if="isShow">
    <div
      class="flex flex-column flex-row-ns f7 f6-ns mw8 center pv2 pv3-ns pl3 pr3 pr0-ns lh-copy items-center"
    >
      <div>
        {{ $t("content") }}
      </div>
      <div class="flex flex-row w-100 w-auto-ns mt2 mt0-ns">
        <button
          class="accept-btn bg-white bn dark-red br-pill f6 ph2 ph3-ns mb2-ns mb0-ns ml4-ns mr2 mr3-ns pointer b tc"
          @click="setPDPA"
        >
          {{ $t("accept") }}
        </button>
        <a
          :href="pdpaLink"
          class="learn-more-btn bg-white bn dark-red br-pill f6 ph2 ph3-ns pointer nowrap b link tc"
        >
          {{ $t("learnMore") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      isShow: true,
      pdpaLink: "https://hungryhub.zendesk.com/hc/en-us/articles/360009040074"
    };
  },
  mounted() {
    this.checkPDPA();
  },
  methods: {
    checkPDPA() {
      const PDPA = Cookies.get("pdpa");
      if (PDPA == "true") {
        this.isShow = false;
      }
    },
    setPDPA() {
      // set pdpa cookie for 10 year
      Cookies.set("pdpa", true, { expires: 3650 });
      document
        .getElementsByClassName("pdpa-container")[0]
        .classList.add("slide-bottom");
    }
  }
};
</script>

<style scoped>
.pdpa-container {
  z-index: 9999999;
  background-color: #272727;
  color: #cdcdcd;
}
.accept-btn {
  width: 120px;
  height: 25px;
  line-height: 25px;
}
.learn-more-btn {
  width: 120px;
  height: 25px;
  line-height: 25px;
}
@media (min-width: 480px) {
  .accept-btn {
    width: 120px;
    height: 35px;
    line-height: 35px;
  }
  .learn-more-btn {
    width: 120px;
    height: 35px;
    line-height: 35px;
  }
}
.slide-bottom {
  animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@keyframes slide-bottom {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}
</style>
<i18n>
{
  "en": {
    "content": "This website uses cookies to present you the contents and advertising that you may interest in the better experience on our website. If you still continue using our website, we believe that you are accepted in our Terms & Conditions.",
    "learnMore": "Learn more",
    "accept": "Accept"
  },
  "th": {
    "content": "เว็บไซต์นี้ใช้คุกกี้ เพื่อนำเสนอคอนเทนต์และโฆษณาที่ท่านอาจสนใจเพื่อให้ท่านได้รับประสบการณ์ที่ดีบนบริการของเรา
หากท่านใช้บริการบนเว็บไซต์ของเราต่อไป เราเข้าใจว่าท่านยินยอมที่จะรับคุกกี้บนเว็บไซต์ของเรา ",
"learnMore": "เรียนรู้เพิ่มเติม",
"accept": "ยอมรับ"
  }
}
</i18n>
